import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

// キャンセル理由の選択肢 (ゲストアプリの設計 JPTP_CANSEI-1269 の表示内容に準拠)。
// 選択値は CancelConfirmStep で proto の CancelReasonCode へ対応付けて CancelReservation へ送る。
const REASON_CODES = ["cannotAttend", "bookOther", "notAsExpected", "other"] as const;
export type CancelReasonCode = (typeof REASON_CODES)[number];

type Props = {
  reasonCode: CancelReasonCode | null;
  reasonNote: string;
  onReasonCodeChange: (value: CancelReasonCode) => void;
  onReasonNoteChange: (value: string) => void;
};

/**
 * キャンセル理由 (任意) セクション。ラジオボタンで理由を選び、下のテキストエリアに
 * 自由記述を入力できる。
 */
export function CancelReasonSection({
  reasonCode,
  reasonNote,
  onReasonCodeChange,
  onReasonNoteChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: colors.text, mb: 0.5 }}>
        {t("cancelReservation.reasonTitle")}
      </Typography>
      <Typography sx={{ color: colors.textSub, fontSize: 14, mb: 1.5 }}>
        {t("cancelReservation.reasonSubText")}
      </Typography>
      <RadioGroup
        value={reasonCode ?? ""}
        onChange={(e) => onReasonCodeChange(e.target.value as CancelReasonCode)}
        aria-label={t("cancelReservation.reasonTitle")}
      >
        {REASON_CODES.map((code) => (
          <FormControlLabel
            key={code}
            value={code}
            control={<Radio color="secondary" />}
            label={t(`cancelReservation.reasonOptions.${code}`)}
          />
        ))}
      </RadioGroup>
      <TextField
        value={reasonNote}
        onChange={(e) => onReasonNoteChange(e.target.value)}
        multiline
        minRows={3}
        fullWidth
        placeholder={t("cancelReservation.reasonNotePlaceholder")}
        aria-label={t("cancelReservation.reasonNotePlaceholder")}
        sx={{ mt: 1 }}
      />
    </Box>
  );
}
